import { render, staticRenderFns } from "./ProxySignUp.vue?vue&type=template&id=1f3a90e4&scoped=true&"
import script from "./ProxySignUp.js?vue&type=script&lang=js&"
export * from "./ProxySignUp.js?vue&type=script&lang=js&"
import style0 from "./ProxySignUp.scss?vue&type=style&index=0&id=1f3a90e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a90e4",
  null
  
)

export default component.exports